const states = {
  isToBUser: false,           // 是否为分销人员
  userCompanyObject: {},      // 保险员公司信息
  orderList: [],              // 订单列表
  orderDetailObject: {},      // 订单详情
  orderDetailReceiveList: [], // 订单详情中的领取数据
  shareOrderDetailObject: {}, // 分享批次详情
  shareReceivedList: [],      // 分享批次领取数据
  shareReceivedObject: null,  // 分享批次领取数据(包含领取数量)
  giveNumber: 0,              // 添加批次的领取数量
};
export default states;
